export const mutations = {
  setNotificationsConfig(state, payload) {
    // eslint-disable-next-line no-console
    state.defaultConfig = payload.map(item => {
      const patern = /-/gi;

      let tmpPhoneNumber = item.phone_number.replace(patern, "");
      let tmpNumberOnly = tmpPhoneNumber.substring(
        tmpPhoneNumber.length,
        tmpPhoneNumber.length - 10
      );
      let tmpLadaOnly = tmpPhoneNumber.replace(tmpNumberOnly, "");

      return {
        carrier_id: item.carrier_id,
        enabled: item.enabled === 1 ? true : false,
        phone_number: item.phone_number,
        number_only: tmpNumberOnly,
        lada_only: tmpLadaOnly
      };
    });
  },
  setNotificationsConfigByTrip(state, payload) {

    var tmpNumberOnly = ""
    var tmpLadaOnly = ""

    if (payload.response) {
      const patern = /-/gi;

      var tmpPhoneNumber = payload.response.phone_number.replace(patern, "");
      tmpNumberOnly = tmpPhoneNumber.substring(
        tmpPhoneNumber.length,
        tmpPhoneNumber.length - 10
      );
      tmpLadaOnly = tmpPhoneNumber.replace(tmpNumberOnly, "");
    }

    let tmpEnabled = false
    if ( payload.response ) {
      tmpEnabled = payload.response.enabled === 1 ? true : false;
    }

    state.tripNotConfig = {
      phone_number: payload.response ? tmpNumberOnly : "",
      lada_number: payload.response ? tmpLadaOnly : "",
      enabled: tmpEnabled,
      tripId: payload.data.tripId
    };
  },
  setEmptyPhoneNumber(state) {
    if (state.defaultConfig.length <= 1) {
      state.defaultConfig.push({
        carrier_id: "",
        enabled: true,
        phone_number: "",
        number_only: "",
        lada_only: ""
      });
    }
  }
};
